import { AnimatedLineProps } from '@mui/x-charts-pro';
import { useChartsHighlightContext } from 'components/charts/inc-charts.context';

function HighlightedLine(props: AnimatedLineProps) {
  const { d, ownerState, className, skipAnimation, ...other } = props;
  const { isHighlighted, isFaded } = useChartsHighlightContext();

  return (
    <>
      <path
        d={d}
        stroke={ownerState.color}
        strokeWidth={isHighlighted(ownerState.id) ? 4 : 2}
        strokeLinejoin="round"
        fill="none"
        filter={isHighlighted(ownerState.id) ? 'brightness(120%)' : undefined}
        opacity={isFaded(ownerState.id) ? 0.3 : 1}
        className={className}
      />
      <path
        d={d}
        stroke="transparent"
        strokeWidth={8}
        fill="none"
        className="interaction-area"
        {...other}
      />
    </>
  );
}

export default HighlightedLine;
